// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2B2LV","disabled":"FileBtn_disabled__2IRY6","warn":"FileBtn_warn__3QdgP","fade":"FileBtn_fade__3hBgM"};